export const DESTINATION_OPTIONS = [
  'Estados Unidos',
  'Europa',
  'Asia',
  'Asia Central',
  'Centroamérica',
  'Cono Sur',
  'Sudamérica',
  'Caribe',
  'Medio Oriente',
  'México',
  'Canadá',
  'África',
  'Oceanía',
  'Otros',
  'No especificado',
];

export const normalizeDestinationKey = (value = '') =>
  value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const destinationRules = [
  {
    label: 'No especificado',
    match: /^(n a|na|n d|nd|sin dato|sin destino|no especificado|no aplica)$/,
  },
  {
    label: 'Asia Central',
    match: /\b(asia central|central asia|kazajstan|kazakhstan|uzbekistan|uzbequistan|turkmenistan|kirguistan|tayikistan)\b/,
  },
  {
    label: 'Medio Oriente',
    match: /\b(medio oriente|oriente medio|middle east|emiratos|dubai|qatar|arabia|saudi|israel|turquia|turkey|oman|kuwait)\b/,
  },
  {
    label: 'Estados Unidos',
    match: /\b(estados unidos|ee uu|eeuu|usa|u s a|united states|estados unidos de america)\b/,
  },
  { label: 'México', match: /\b(mexico|mex)\b/ },
  { label: 'Canadá', match: /\b(canada)\b/ },
  {
    label: 'Centroamérica',
    match: /\b(centroamerica|america central|central america|guatemala|honduras|salvador|nicaragua|costa rica|panama|belice)\b/,
  },
  {
    label: 'Caribe',
    match: /\b(caribe|caribbean|republica dominicana|dominicana|puerto rico|jamaica|trinidad|curacao|aruba|haiti|cuba)\b/,
  },
  {
    label: 'Cono Sur',
    match: /\b(cono sur|chile|argentina|uruguay|paraguay)\b/,
  },
  {
    label: 'Sudamérica',
    match: /\b(sudamerica|suramerica|america del sur|south america|colombia|peru|brasil|bolivia|venezuela|ecuador)\b/,
  },
  {
    label: 'Europa',
    match: /\b(europa|europe|union europea|ue|alemania|paises bajos|holanda|netherlands|belgica|espana|italia|francia|reino unido|uk|inglaterra|rusia|polonia)\b/,
  },
  {
    label: 'Asia',
    match: /\b(asia|asia pacifico|apac|china|japon|japan|corea|korea|india|singapur|singapore|taiwan|hong kong|vietnam|tailandia|malasia|indonesia|filipinas)\b/,
  },
  {
    label: 'África',
    match: /\b(africa|sudafrica|south africa|egipto|marruecos|kenia|nigeria)\b/,
  },
  {
    label: 'Oceanía',
    match: /\b(oceania|australia|nueva zelanda|new zealand)\b/,
  },
  {
    label: 'Otros',
    match: /\b(otro|otros|global|varios|multiple|multiples)\b/,
  },
];

export const normalizeDestination = (value = '') => {
  const key = normalizeDestinationKey(value);
  if (!key) return 'No especificado';

  const exactOption = DESTINATION_OPTIONS.find((option) => normalizeDestinationKey(option) === key);
  if (exactOption) return exactOption;

  const rule = destinationRules.find((item) => item.match.test(key));
  return rule?.label || 'Otros';
};
